import { useState, useLayoutEffect } from "react";

const useWindowSize = () => {
  const [size, setSize] = useState();
  useLayoutEffect(() => {
    function updateSize() {
      setSize({ width: window.innerWidth, height: window.innerHeight });
    }
    window.addEventListener("resize", updateSize);
    updateSize();
    return () => window.removeEventListener("resize", updateSize);
  }, []);
  return { size };
};

export default useWindowSize;
